import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import AZ from '../../assets/logos/azb.png';

// Palette white / beige / gold
const colors = {
  goldLight: '#F5E1C8',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  text: '#3B2F2A',
  textSoft: '#5C4A3D',
  glassBg: 'rgba(255, 255, 255, 0.7)',
  glassBorder: 'rgba(198, 156, 109, 0.25)',
  shadow: '0 8px 24px rgba(107, 90, 70, 0.06)',
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 25 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const BannerArea3 = () => {
  return (
    <>
      <style>{`
        .services-banner {
          position: relative;
          padding: 90px 0 70px;
          background: linear-gradient(135deg, #faf9f7 0%, #faf9f8 30%, #fcfbf9 60%, #fcfbfa 100%);
          background-size: 400% 400%;
          animation: goldGradient 15s ease infinite;
          overflow: hidden;
          text-align: center;
        }

        @keyframes goldGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        /* Orbes floues */
        .services-banner::before,
        .services-banner::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.35;
          z-index: 0;
          pointer-events: none;
        }

        .services-banner::before {
          width: 40vw;
          height: 40vw;
          background: #F5E1C8;
          top: -15%;
          left: -10%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .services-banner::after {
          width: 35vw;
          height: 35vw;
          background: #E8CFB5;
          bottom: -10%;
          right: -5%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .container {
          position: relative;
          z-index: 2;
        }

        /* Logo glass */
        .logo-glass {
          display: inline-block;
          background: ${colors.glassBg};
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid ${colors.glassBorder};
          border-radius: 24px;
          padding: 15px 30px;
          box-shadow: ${colors.shadow};
          margin-bottom: 30px;
        }

        .logo-img {
          width: 220px;
          height: auto;
          filter: drop-shadow(0 4px 6px rgba(0,0,0,0.05));
        }

        .banner-title {
          font-size: clamp(2rem, 6vw, 3rem);
          font-weight: 700;
          color: ${colors.text};
          margin-bottom: 25px;
          letter-spacing: -0.5px;
        }

        /* Fil d'Ariane glass */
        .breadcrumb-glass {
          display: inline-flex;
          align-items: center;
          background: ${colors.glassBg};
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid ${colors.glassBorder};
          border-radius: 50px;
          padding: 12px 28px;
          list-style: none;
          margin: 0;
          gap: 8px;
          box-shadow: ${colors.shadow};
        }

        .breadcrumb-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 1rem;
          font-weight: 500;
          color: ${colors.textSoft};
        }

        .breadcrumb-item a {
          color: ${colors.textSoft};
          text-decoration: none;
          transition: color 0.2s;
        }

        .breadcrumb-item a:hover {
          color: ${colors.gold};
        }

        .breadcrumb-item.active {
          color: ${colors.gold};
          font-weight: 600;
        }

        .breadcrumb-separator {
          color: ${colors.gold};
          font-size: 0.9rem;
        }

        @media (max-width: 768px) {
          .services-banner {
            padding: 70px 0 50px;
          }
          .logo-glass {
            padding: 10px 20px;
          }
          .logo-img {
            width: 180px;
          }
          .breadcrumb-glass {
            padding: 10px 20px;
            flex-wrap: wrap;
            justify-content: center;
          }
        }
      `}</style>

      <section className="services-banner mt-5">
        <div className="container">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {/* Logo */}
            <motion.div variants={itemVariants}>
              <div className="logo-glass">
                <img src={AZ} alt="Azyekos Logo" className="logo-img" />
              </div>
            </motion.div>

            {/* Titre */}
            <motion.h1 className="banner-title" variants={itemVariants}>
              Nos Services
            </motion.h1>

            {/* Fil d'Ariane */}
            <motion.nav variants={itemVariants} aria-label="breadcrumb">
              <ol className="breadcrumb-glass">
                <li className="breadcrumb-item">
                  <Link to="/">Accueil</Link>
                  <FaChevronRight className="breadcrumb-separator" />
                </li>
                <li className="breadcrumb-item">
                  <Link to="/about">Qui Sommes Nous</Link>
                  <FaChevronRight className="breadcrumb-separator" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Nos Services
                </li>
              </ol>
            </motion.nav>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default BannerArea3;